import { z } from 'zod'

export const MEASURES = ['uvc', 'ca', 'tonnage'] as const
export const SEGMENTS = ['uf', 'commercial', 'industriel', 'reappro'] as const

export type Measure = (typeof MEASURES)[number]
export type Segment = (typeof SEGMENTS)[number]

export const previsionsSearchSchema = z.object({
  storeIds: z.array(z.number().int().positive()).optional().default([]),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  categoryIds: z.array(z.number().int().positive()).optional().default([]),
  measure: z.enum(MEASURES).optional().default('tonnage'),
  chartSegment: z.enum(SEGMENTS).optional().default('commercial'),
  tableSegment: z.enum(SEGMENTS).optional().default('commercial'),
})

export type PrevisionsSearch = z.infer<typeof previsionsSearchSchema>

export const MEASURE_LABELS: Record<Measure, string> = {
  uvc: 'UVC',
  ca: 'CA',
  tonnage: 'Tonnage',
}

export const SEGMENT_LABELS: Record<Segment, string> = {
  uf: 'Ultra-Frais',
  commercial: 'Commercial',
  industriel: 'Industriel',
  reappro: 'Réappro',
}

/** Axe de regroupement attendu par l'endpoint des séries journalières. */
export const SEGMENT_GROUP_BY: Record<Segment, 'uf' | 'category' | 'internal' | 'reappro'> = {
  uf: 'uf',
  commercial: 'category',
  industriel: 'internal',
  reappro: 'reappro',
}
